import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// Supported languages configuration
export const LANGUAGES = {
  en: { code: 'en', name: 'English', flag: '🇬🇧' },
  vi: { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' },
  pl: { code: 'pl', name: 'Polski', flag: '🇵🇱' }
};

export const DEFAULT_LANGUAGE = 'en';
export const FALLBACK_LANGUAGE = 'en';

// Initialize i18next
i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: FALLBACK_LANGUAGE,
    supportedLngs: ['en', 'vi', 'pl'],
    defaultNS: 'common',
    ns: ['common', 'navigation', 'forms', 'errors'],
    interpolation: {
      escapeValue: false // React already escapes
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
    detection: {
      order: ['path', 'navigator'],
      lookupFromPathIndex: 0,
      caches: [] // Don't cache - LanguageContext handles persistence via URL
    },
    react: {
      useSuspense: false
    },
    saveMissing: process.env.NODE_ENV === 'development', // Log missing keys in development
    missingKeyHandler: (lngs, ns, key) => {
      if (process.env.NODE_ENV === 'development') {
        console.warn(`Missing translation key: ${key} in namespace ${ns} for languages: ${lngs.join(', ')}`);
      }
    }
  });

// Translation loading error handler
i18n.on('failedLoading', (lng, ns, msg) => {
  console.error(`Failed to load translations for ${lng}/${ns}: ${msg}`);
  // Fallback is automatic via i18next configuration
  // Optionally show user notification (can be implemented with a toast library)
  if (process.env.NODE_ENV === 'development') {
    console.warn('Translation loading failed. Using fallback language (English).');
  }
});

// Log when language changes (for debugging)
i18n.on('languageChanged', (lng) => {
  console.log(`Language changed to: ${lng}`);
  document.documentElement.lang = lng; // Update HTML lang attribute
});

export default i18n;
